import { Flex, Tabs, TextInput } from "@mantine/core";
import { FormRow } from "../../common/Form/FormRow";
import Container from "../../common/Container";
import PageHeader from "../../common/PageHeader";
import { useForm } from "@mantine/form";
import { validateRequired } from "../../../utils/validations";
import { updateDepartmentById, getDepartmentById } from "../../../api/departmentApi";
import { updateNotification } from "../../../utils/useNotification";
import { useNavigate, useParams, useSearchParams } from "react-router";
import { useEffect, useRef, useState } from "react";
import { useAuth } from "../../../context/AuthContext";
import SaveIcon from "../../common/Icons/SaveIcon";
import DepartmentTeams from "./DepartmentTeams";

/**
 * DEPARTMAN GÜNCELLE.
 *
 * ⚠ Departman ÇALIŞMA DÜZENİ TAŞIMAZ (plan 2.35, 21 Ağu). Kaldırılanlar:
 * haftalık mesai planı (`WeeklySchedule`), "Gün Kesim Saati" ve "Mesai
 * Önceliği". Sonuncusu yalnızca "personel birden çok departmandaysa hangisinin
 * mesaisi geçerli" sorusunu cevaplıyordu; departman saat taşımayı bırakınca
 * sorunun kendisi kalktı.
 *
 * Bu alanların yerine geçen: Vardiyalar → Vardiya Listesi (haftalık desen,
 * gün kesimi, geç/erken toleransı) + Personel Atama, ya da dönüşümlü düzen
 * için Ekipler + Rotalar.
 *
 * ── SEKMELER ───────────────────────────────────────────────────────────────
 * 2.35 departmandan çalışma düzenini alınca geriye ad + açıklama kaldı ve ekran
 * boş göründü. **Ekipler** sekmesi o boşluğu uydurma bir alanla değil, ZATEN
 * departmana ait olan bir kavramla dolduruyor: ekip `departmentId` olmadan
 * kaydedilemiyor. Ekip açmanın doğal yeri burası — departman hazır gelir.
 */
const UpdateDepartment = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get("tab") === "teams" ? "teams" : "info";
  const formRef = useRef<HTMLFormElement>(null);
  const { refetchDepartmentSelectData } = useAuth();
  const [isLoading, setIsLoading] = useState(true);
  const [departmentName, setDepartmentName] = useState("");

  const form = useForm<any>({
    initialValues: { name: "", description: "" },
    validate: { name: validateRequired, description: validateRequired },
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data }: any = await getDepartmentById({ id });
        const department = data?.response;
        setDepartmentName(department?.name ?? "");
        form.setValues({
          name: department?.name ?? "",
          description: department?.description ?? "",
        });
      } catch (error) {
        console.error("Error:", error);
      } finally {
        setIsLoading(false);
      }
    };
    if (id) fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const handleSubmit = async (values: any) => {
    try {
      const { data }: any = await updateDepartmentById({ id, updates: values });
      if (data?.success) {
        updateNotification(data?.success);
        refetchDepartmentSelectData();
        navigate(-1);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  if (isLoading) return null;

  return (
    <Container>
      <PageHeader
        pageTitle={departmentName || "Departman Güncelle"}
        subText="Departman bir organizasyon birimidir; çalışma saatleri Vardiyalar bölümünden tanımlanır."
        // Kaydet düğmesi yalnızca Bilgiler sekmesine ait: Ekipler sekmesinin
        // kendi kaydetme akışı var, orada durması "neyi kaydediyorum" sorusunu
        // doğururdu.
        isButtoned={tab === "info"}
        buttonText="Kaydet"
        buttonIcon={<SaveIcon />}
        buttonOnClick={() => formRef.current?.requestSubmit()}
      />

      <Tabs
        value={tab}
        onChange={(value) =>
          setSearchParams(value === "teams" ? { tab: "teams" } : {})
        }
        color="#5C26FF"
        keepMounted={false}
      >
        <Tabs.List mb={24}>
          <Tabs.Tab value="info">Bilgiler</Tabs.Tab>
          <Tabs.Tab value="teams">Ekipler</Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value="info">
          <form
            ref={formRef}
            style={{ display: "flex", flexDirection: "column", gap: "24px" }}
            onSubmit={form.onSubmit(handleSubmit)}
          >
            <FormRow $gap={12}>
              <TextInput
                label="Departman İsmi"
                placeholder="Departman İsmi Giriniz."
                radius={10}
                maxLength={40}
                size="md"
                {...form.getInputProps("name")}
              />
              <TextInput
                label="Departman Açıklaması"
                placeholder="Departman Açıklaması Giriniz."
                radius={10}
                maxLength={150}
                size="md"
                {...form.getInputProps("description")}
              />
            </FormRow>
          </form>
        </Tabs.Panel>

        <Tabs.Panel value="teams">
          {id && (
            <DepartmentTeams
              departmentId={id}
              departmentName={departmentName || "bu departman"}
            />
          )}
        </Tabs.Panel>
      </Tabs>
    </Container>
  );
};

export default UpdateDepartment;
